module.exports = __webpack_public_path__ + "img/tanker.f547d1d3.svg";